import React, { useContext } from 'react';
import { createContext } from 'react';
// @ts-ignore
export const FuegoContext = /*#__PURE__*/createContext(null);
export let fuego;
export const getFuego = () => {
  if (!fuego) throw new Error('Fuego instance not initialized. Have you initialized the FuegoProvider yet?');
  return fuego;
};
export const setFuego = f => fuego = f;
export const useFuegoContext = () => {
  const context = useContext(FuegoContext);
  return context;
};
export const FuegoProvider = _ref => {
  let {
    children,
    fuego
  } = _ref;
  setFuego(fuego);
  return /*#__PURE__*/React.createElement(FuegoContext.Provider, {
    value: {
      fuego
    }
  }, children);
};
//# sourceMappingURL=Provider.js.map